import { DesignTokens, Select, Button as MelcoButton } from "melco-ui";
import { useTranslation } from "react-i18next";

import { LogsTable } from "./LogsTable";
import { CenteredMessage, Breadcrumb, Crumb, TopBar, OrderLabel } from "./digitizingOrdersLogsStyled";

const { colors } = DesignTokens;

type LogsPanelProps = {
  selectedUser: any | null;
  selectedOrder: any | null;
  filteredLogs: any[];
  logsLoading: boolean;
  statusFilter: string | undefined;
  onStatusFilterChange: (status: string | undefined) => void;
  onRefresh: () => void;
};

// WHAT: the rightmost "Step 3 — logs" column.
// WHY a dedicated component: same reasoning as OrdersPanel — this was
// previously ~70 lines inlined in SummitWorkspace's JSX. As its own
// component it only needs to know "here's a order and some logs",
// not how either of those was fetched, which keeps it trivially
// testable (pass in props, assert on rendered output) and reusable if
// another screen ever needs a similar logs view.
export const LogsPanel: React.FC<LogsPanelProps> = ({
  selectedUser,
  selectedOrder,
  filteredLogs,
  logsLoading,
  statusFilter,
  onStatusFilterChange,
  onRefresh,
}) => {
  const { t } = useTranslation();

  if (!selectedOrder) {
    return (
      <CenteredMessage>
        {t("summit.select_order_prompt", { defaultValue: "Select a order to view its logs" })}
      </CenteredMessage>
    );
  }

  return (
    <>
      <Breadcrumb>
        <Crumb>
          {selectedUser?.first_name} {selectedUser?.last_name}
        </Crumb>
        <span>&rsaquo;</span>
        <Crumb>{selectedOrder?.design_name || selectedOrder?.id}</Crumb>

      </Breadcrumb>

      <TopBar>
        <OrderLabel>{selectedOrder?.design_name || selectedOrder?.id}</OrderLabel>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: colors.gray.middle }}>Event Type</span>
        <Select
          allowClear
          placeholder="All"
          style={{ width: 110 }}
          value={statusFilter}
          onChange={onStatusFilterChange}
          options={[
            { label: "Created", value: "created" },
            { label: "Updated", value: "updated" },
            { label: "Processing", value: "processing" },
            { label: "Submitted", value: "submitted" },
            { label: "Completion", value: "completion" },

          ]}
        />
        <MelcoButton onClick={onRefresh}>
          {t("summit.buttons.refresh", { defaultValue: "Refresh" })}
        </MelcoButton>
      </TopBar>

      <LogsTable dataSource={filteredLogs} loading={logsLoading} />

    </>
  );
};
